import { render, staticRenderFns } from "./colorSize.vue?vue&type=template&id=63af7983&scoped=true"
import script from "./colorSize.vue?vue&type=script&lang=js"
export * from "./colorSize.vue?vue&type=script&lang=js"
import style0 from "./colorSize.vue?vue&type=style&index=0&id=63af7983&prod&lang=scss&scoped=true"
import style1 from "./colorSize.vue?vue&type=style&index=1&id=63af7983&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63af7983",
  null
  
)

export default component.exports